import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuthContext } from '../context/AuthContext';
import SidebarLayout from './SideBarLayout';

const Auth = () => {
    const navigate = useNavigate();
    const { setAuthState } = useAuthContext();

    useEffect(() => {
        const urlParams = new URLSearchParams(window.location.search);
        const code = urlParams.get('code');
        console.log(`sending request to this url: ${process.env.MULTIVAC_URL}/auth/linkedin`)
        if (code) {
            fetch(`${process.env.REACT_APP_MULTIVAC_URL}/auth/linkedin`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    code,
                    redirect_uri: process.env.REACT_APP_LINKEDIN_REDIRECT_URI
                }),
            })
                .then(response => response.json())
                .then(data => {
                    console.log('User Info from Backend:', data.user);
                    console.log({ data })
                    if (data && data.user && data.token)
                        setAuthState({
                            isAuthenticated: true,
                            user: {
                                ...data.user,
                                token: data.token
                            }
                        });
                    if (data.error) {
                        alert('Error logging in: ' + data.error)
                    }
                    navigate('/');
                })
                .catch(error => console.error('Authentication error:', error));
        }
    }, [navigate, setAuthState]);

    return (
        <SidebarLayout sidebarContent={
            <>
            </>
        }
            mainContent={
                <div>
                    <p>Logging in... Please wait.</p>
                </div>
            }
        />

    );
};

export default Auth; 
